import { render, staticRenderFns } from "./SingleQTV.vue?vue&type=template&id=7a7501cd&scoped=true"
import script from "./SingleQTV.vue?vue&type=script&lang=ts&setup=true"
export * from "./SingleQTV.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SingleQTV.vue?vue&type=style&index=0&id=7a7501cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7501cd",
  null
  
)

export default component.exports